import { Printer, Scissors, Shirt, Sparkles } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import DesignCTA from "@/components/DesignCTA";
import { HOW_IT_WORKS, SERVICES, IMAGES } from "@/data/content";

const SERVICE_ICONS = { sublimation: Shirt, "cut-sew": Scissors, printing: Printer, embroidery: Sparkles };

export default function CustomManufacturing() {
  return (
    <>
      <PageHero
        testId="manufacturing-hero"
        eyebrow="Manufacturing"
        title="Custom Manufacturing"
        sub="Every order is produced to the customer's own design and requirements — from first concept to finished, packed teamwear."
        img={IMAGES.craftMachine}
      />

      <section className="py-14 md:py-20" data-testid="manufacturing-services">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-9">
            <Reveal><p className="eyebrow mb-3">Our services</p></Reveal>
            <Reveal delay={0.08}>
              <h2 className="h2">Four ways we build your apparel</h2>
            </Reveal>
          </div>
          <div className="grid sm:grid-cols-2 gap-6">
            {SERVICES.map((s, i) => {
              const Icon = SERVICE_ICONS[s.id];
              return (
                <Reveal key={s.id} delay={i * 0.06}>
                  <div className="h-full bg-white rounded-lg border border-slate-200 p-8 hover:border-ice/60 hover:shadow-md transition-all duration-300" data-testid={`service-${s.id}`}>
                    <span className="inline-flex rounded-md bg-icelight p-3">
                      <Icon size={22} className="text-icehover" strokeWidth={1.8} />
                    </span>
                    <h3 className="mt-5 font-display font-semibold uppercase text-2xl text-navy">{s.name}</h3>
                    <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pb-14 md:pb-20" data-testid="manufacturing-process">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mb-9">
            <Reveal><p className="eyebrow mb-3">The process</p></Reveal>
            <Reveal delay={0.08}>
              <h2 className="h2">How it works</h2>
            </Reveal>
          </div>
          <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-4">
            {HOW_IT_WORKS.map((s, i) => (
              <Reveal key={s.step} delay={i * 0.05}>
                <div className="h-full bg-white rounded-lg border border-slate-200 p-6" data-testid={`mfg-step-${s.step}`}>
                  <span className="font-display font-bold text-3xl text-ice">{s.step}</span>
                  <h3 className="mt-4 font-display font-semibold uppercase text-lg text-navy leading-tight">{s.name}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <DesignCTA />
    </>
  );
}
